export const componentRef = 'pdf-viewer';
